import React, { useState, useEffect, useRef } from 'react';
import { LuArrowDownUp } from "react-icons/lu";
import { isValidate, resetStartSearch, startsearch } from '../components/services/api';
import { useNavigate } from 'react-router-dom';
import { IoIosSearch } from 'react-icons/io';
import usePagination from '../components/hooks/usePagination';
import Pagination from '../components/Pagination';
import EventFilterModal from '../components/EventFilterModal';

export default function TrendingEvents() {
  const [events, setEvents] = useState([]);
  const [selectedEvnet, setSelectedEvent] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const handleHide = () => setShowModal(false);
  const handleShow = () => setShowModal(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const ranOnce = useRef(false);

  const [messageType, setMessageType] = useState('');
  const [message, setMessage] = useState('');

  const [searchIndex, setSearchIndex] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);


  const [eventName, setEventName] = useState('');
  const [eventVenue, setEventVenue] = useState('');
  const [eventCity, setEventCity] = useState('');
  const [eventState, setEventState] = useState('');
  const [remainingSeats, setRemainingSeats] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const searchEvents = events.filter(event => !searchTerm || (event.EventName && event.EventName.toLowerCase().includes(searchTerm.toLowerCase())));

  const {
    currentPage,
    totalPages,
    currentData,
    goToPage,
    rowsPerPage,
    changeRowsPerPage
  } = usePagination(searchEvents, 10);
  const isLastPage = currentPage === totalPages;
  //>= totalPages - 1;

  const formateDateTime = (dateString) => {
    const date = new Date(dateString);
    const dateOptions = {
      weekday: 'short', year: 'numeric', month: 'long', day: 'numeric'
    };
    const timeOptions = {
      hour: 'numeric', minute: '2-digit', hour12: true
    };
    const formatedDate = date.toLocaleString('en-US', dateOptions);
    const formatedTime = date.toLocaleTimeString('en-US', timeOptions);
    return { formatedDate, formatedTime };
  };

  useEffect(() => {
    if (ranOnce.current) return;
    ranOnce.current = true;
    const checkValidation = async () => {
      try {
        const response = await isValidate();
        if (response.d === true) {
          await populateUpcomingEvents();
        }
        else {
          if (response.d === false) {
            navigate("/");
          }
          else {
            navigate("/");
          }
        }
      } catch (error) {
        navigate("/");
      }
    };
    checkValidation();
  }, []);

  const handleFilterApply = (eventLink, filterDetails) => {
    setEvents(prevEvents =>
      prevEvents.map(ev => {
        if (ev.EventLink === eventLink) {
          return {
            ...ev,
            hasFilter: true,
            filter: filterDetails,
            EventName: filterDetails.eventname,
            EventVenue: filterDetails.eventvenue,
            EventDate: filterDetails.eventdate,
            minPrice: filterDetails.priceFrom,
            maxPrice: filterDetails.priceTo,
            sections: filterDetails.sect,
            area: filterDetails.area.split(","),
            selectedType: filterDetails.ticketType,
            // ? filterDetails.sect.split(",").filter(s => s !== "")
            // : ev.sections
          }
        };
        return ev;
      }
      )
    );
    setShowModal(false);
  };

  const populateUpcomingEvents = async () => {
    try {
      const response = await startsearch(eventName, eventVenue, eventCity, eventState, remainingSeats, fromDate, toDate, searchIndex);
      if (response && response.d) {
        const formatedEvents = response.d.map((item) => ({
          EventName: item.eventname,
          EventVenue: item.eventvenue,
          EventCity: item.eventCity,
          EventState: item.eventState,
          EventDate: item.eventDate,
          EventLink: item.eventUrl

        }));
        setEvents(formatedEvents);
      }
      else {
        console.log('Error Occur');
      }
    } catch (error) {
      console.error("Error fetching trending events:", error);
    }
  };

  const callSearchAPI = async (pageIndex) => {
    const response = await startsearch(eventName, eventVenue, eventCity, eventState, remainingSeats, fromDate, toDate, pageIndex);
    return response;
    // if (response && response.d) {
    //   const formatedEvents = response.d.map((item) => ({
    //     EventName: item.eventname,
    //     EventVenue: item.eventvenue,
    //     EventCity: item.eventCity,
    //     EventState: item.eventState,
    //     EventDate: item.eventDate,
    //     EventLink: item.eventUrl
    //   }));
    //   setEvents(formatedEvents);
    // }
  };

  const handleShowMore = async () => {
    if (loadingMore) return;
    try {
      const nextIndex = searchIndex + 1;
      setLoadingMore(true);
      setSearchIndex(nextIndex);
      const response = await callSearchAPI(nextIndex);
      if (response && response.d) {
        const formatedEvents = response.d.map((item) => ({
          EventName: item.eventname,
          EventVenue: item.eventvenue,
          EventCity: item.eventCity,
          EventState: item.eventState,
          EventDate: item.eventDate,
          EventLink: item.eventUrl
        }));
        setEvents(prev => [...prev, ...formatedEvents]);
      }
    } catch (error) {
      console.error("Error fetching more events:", error);
    } finally {
      setLoadingMore(false);
    }
  };

  const formateUrl = (url) => {
    if (!url) return;
    const match = url.match(/event\/([^/?]+)/);
    return match ? match[1] : '';
  }

  const handleSort = (columnKey) => {
    //console.log("Pressed sort on:", columnKey);
    let direction = 'asc';
    if (sortConfig.key === columnKey && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    const sortedEvents = [...events].sort((a, b) => {
      const aVal = a[columnKey];
      const bVal = b[columnKey];

      // price -> use min price as sort key
      if (columnKey === 'price') {
        const getMin = (arr) =>
          Array.isArray(arr) && arr.length ? Math.min(...arr) : Infinity;

        return direction === 'asc'
          ? getMin(a.price) - getMin(b.price)
          : getMin(b.price) - getMin(a.price);
      }

      // date -> convert to timestamp
      if (columnKey === 'EventDate') {
        const aTime = aVal ? new Date(aVal).getTime() : 0;
        const bTime = bVal ? new Date(bVal).getTime() : 0;

        return direction === 'asc' ? aTime - bTime : bTime - aTime;
      }

      // normalize strings (EventName, EventVenue, etc.)
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return direction === 'asc'
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }

      // fallback for other types
      if (aVal < bVal) return direction === 'asc' ? -1 : 1;
      if (aVal > bVal) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setEvents(sortedEvents);
    setSortConfig({ key: columnKey, direction })
  };

  const openFilterModal = async (event) => {
    setSelectedEvent(event);
    setShowModal(true);
  }

  const startSearchEvent = async (e) => {
    e.preventDefault();
    setMessageType('');
    setMessage('');
    setHasMore(true);
    try {
      setSearchIndex(0);
      const response = await callSearchAPI(0);

      // const response = await startsearch(eventName, eventVenue, eventCity, eventState, remainingSeats, fromDate, toDate);
      if (response && response.d) {
        const formatedEvents = response.d.map((item) => ({
          EventName: item.eventname,
          EventVenue: item.eventvenue,
          EventCity: item.eventCity,
          EventState: item.eventState,
          EventDate: item.eventDate,
          EventLink: item.eventUrl

        }));
        setEvents(formatedEvents);
        goToPage(1);
      }
      else {
        console.log('Error Occur');
      }
    } catch (error) {

      console.log('Error Occur');
    }
  }

  const resetSearchFields = async () => {
    setEventName('');
    setEventVenue('');
    setEventCity('');
    setEventState('');
    setRemainingSeats(''); setFromDate(''); setToDate('');
    try {
      const response = await resetStartSearch();
      if (response && response.d) {
        const formatedEvents = response.d.map((item) => ({
          EventName: item.eventname,
          EventVenue: item.eventvenue,
          EventCity: item.eventCity,
          EventState: item.eventState,
          EventDate: item.eventDate,
          EventLink: item.eventUrl

        }));
        setEvents(formatedEvents);
      }
      else {
        console.log('Error Occur');
      }
    } catch (error) {
      console.log('Error Occur');

    }
  }

  return (
    <main className='main-container'>
      <div className='container'>
        {/* <div className='main-title mt-3 mb-3'>
          <h5>Trending Events</h5>
        </div> */}
        <div className='row mt-5'>
          <div className='panel-container p-4'>
            <div className='d-flex pb-2 justify-content-between align-items-center'>
              <h5>Advance Search</h5>
              <div className='d-flex align-items-center'>
                <button className='mx-2 btn btn-custom' onClick={startSearchEvent}> <IoIosSearch style={{ fontSize: '18px', marginTop: '-4px' }} /> Search </button>
                <button className='mx-2 btn btn-trash' onClick={resetSearchFields}> Reset </button>
              </div>

            </div>
            <div>
              <form className='row g-2'>
                <div className='col-md-6'>
                  <label htmlFor="" className='ms-1'>Event Name</label>
                  <input type="text" placeholder='Search Event Name' className='form-control' value={eventName} onChange={(e) => setEventName(e.target.value)} />
                </div>
                <div className='col-md-6'><label htmlFor="eventName" className='ms-1'>Event Venue</label><input type="text" placeholder='Search Venue Name' className='form-control' value={eventVenue} onChange={(e) => setEventVenue(e.target.value)} /></div>
                <div className='col-md-6'><label htmlFor="" className='ms-1'>City</label><input type="text" placeholder='Search City' className='form-control' value={eventCity} onChange={(e) => setEventCity(e.target.value)} /></div>
                <div className='col-md-6'><label htmlFor="" className='ms-1'>State</label><input type="text" placeholder='Search State' className='form-control' value={eventState} onChange={(e) => setEventState(e.target.value)} /></div>
                <div> <label htmlFor="" className='ms-1'>Remaining Seats</label><input type="text" placeholder='Search Remaining Seats' className='form-control' value={remainingSeats} onChange={(e) => setRemainingSeats(e.target.value)} /></div>
                <div className='col-md-6'><label htmlFor="from-date" className='ms-1'>From Date</label> <input type="date" name="From_Date" id="from-date" placeholder='From Date' className='form-control' value={fromDate} onChange={(e) => setFromDate(e.target.value)} /></div>
                <div className='col-md-6'><label htmlFor="to-date" className='ms-1'>To Date</label><input type="date" name="To_Date" id="To-date" placeholder='To Date' className='form-control' value={toDate} onChange={(e) => setToDate(e.target.value)} /></div>

              </form>
            </div>
          </div>
        </div>

        <div className='row my-3'>
          <div className='panel-container table-responsive'>

            <div className='d-flex justify-content-between align-items-center p-3'>
              <div className='col-sm-4'>
                <div className="input-group">
                  <span className='input-group-text'><IoIosSearch style={{ fontSize: '20px' }} /></span>
                  <input type="text" className="form-control my-input" placeholder='Search Event Name...' value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} id="" aria-describedby="emailHelp" required />
                </div>
              </div>
              <div>
                {message && <span className={`mt-1 ${messageType === 'success' ? 'text-success' : 'text-danger'}`}> {message} </span>}
                {/* <button className='mx-2 btn btn-trash d-flex align-items-center' onClick={handleDelete} > <FaTrash className='bin me-1' />Add</button> */}

              </div>
            </div>

            <table className='table align-middle text-center'>
              <thead className='mb-4'>
                <tr className='center table-head mb-6 p-2'>
                  {/* <th>Select</th> */}
                  <th colSpan={1}>Event Name <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventName')} /> </th>
                  <th colSpan={1}>Venue <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventVenue')} /></th>
                  <th colSpan={1}>City <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventCity')} /></th>
                  <th colSpan={3}>Date <LuArrowDownUp className='sort-arrow' onClick={() => handleSort('EventDate')} /></th>
                  <th colSpan={2} className='td-nowrap'>Event Url</th>
                  <th colSpan={1}>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length === 0 ? (
                  <tr>
                    <td colSpan={9}>No Upcoming Events Available</td>
                  </tr>
                ) : (
                  currentData.map((event, index) => (
                    <tr key={index} scope='row' className='dashboard-table'>
                      {/* <td><input className='form-check-input' type="checkbox" onChange={() => console.log("toggle")} /></td> */}
                      <td colSpan={1}>{event.EventName}</td>
                      <td colSpan={1}>{event.EventVenue} | {event.EventState}</td>
                      <td colSpan={1} className='td-nowrap'>{event.EventCity}</td>
                      <td colSpan={3}> {event.EventDate}
                        {/* {formateDateTime(event.createdTime).formatedDate} <br /> at {formateDateTime(event.createdTime).formatedTime} */}
                      </td>
                      <td colSpan={2} ><a href={event.EventLink} target="_blank" title={event.EventName}>{formateUrl(event.EventLink)} </a> </td>
                      <td colSpan={1} className='td-nowrap'>
                        <button type='button' onClick={() => openFilterModal(event)} className='btn btn-filter'>+ Add</button>
                      </td>
                    </tr>
                  )
                  ))}
                {
                  hasMore && isLastPage && events.length > 0 && (<tr>
                    <td colSpan={9}>
                      <div className='my-2'>
                        <button className='btn btn-custom' disabled={loadingMore} onClick={handleShowMore}>
                          {loadingMore ? 'Loading...' : 'Show More'}
                        </button>
                      </div>
                    </td>
                  </tr>)
                }
              </tbody>
            </table>

            <EventFilterModal show={showModal} onHide={handleHide}
              eventMeta={selectedEvnet} onApplyFilter={handleFilterApply}>
            </ EventFilterModal>

            <Pagination className="pagination-bar"
              currentPage={currentPage}
              totalPages={totalPages}
              goToPage={goToPage}
              rowsPerPage={rowsPerPage}
              changeRowsPerPage={changeRowsPerPage}
            />
          </div>
        </div>
      </div>
    </main>
  )
}
